var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2023 37.158H2.79758C1.87044 37.158 1.119 36.4064 1.119 35.4794V11.5206C1.119 10.5934 1.87044 9.84201 2.79758 9.84201H44.2023C45.1294 9.84201 45.8809 10.5934 45.8809 11.5206V35.4794C45.8809 36.4064 45.1294 37.158 44.2023 37.158Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6576 10.7148C22.4337 10.7148 27.2097 10.7316 31.9854 10.7036C33.2969 10.6958 34.6085 10.6885 35.92 10.6723C36.0318 10.6706 36.1425 10.6869 36.2539 10.6969C36.7871 10.7434 36.926 11.1697 37.0327 11.619C38.1607 16.3431 37.8028 21.3743 35.7985 25.8176C35.2641 27.002 34.6117 28.1177 33.8905 29.1931C33.3237 30.0386 32.7061 30.8459 32.03 31.6103C31.526 32.1804 30.996 32.7249 30.4339 33.2335C29.3757 34.1909 28.2529 35.0641 26.9435 35.6641C26.249 35.9823 25.5212 36.1815 24.7636 36.2878C24.0083 36.3942 23.2495 36.393 22.4919 36.3764C18.3044 36.2856 14.117 36.3561 9.92948 36.3371C7.76189 36.3277 5.59373 36.3348 3.42614 36.3371C3.19953 36.3371 2.97628 36.3192 2.76254 36.2492C2.31828 36.1049 2.04915 35.7155 2.02397 35.199C2.0167 35.0524 2.01894 34.9053 2.01894 34.7586C2.01894 27.245 2.01838 19.731 2.0195 12.2177C2.0195 12.0029 2.02397 11.7897 2.06594 11.5743C2.16721 11.0589 2.57678 10.7518 3.09657 10.7204C3.27731 10.7092 3.45916 10.7143 3.64043 10.7143C8.31247 10.7154 12.985 10.7154 17.6576 10.7148Z",
    fill: "#2F4653"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8903 31.0966C37.1504 31.0261 37.3619 30.8774 37.5605 30.7185C38.4084 30.0415 39.0384 29.1847 39.5761 28.2515C41.5142 24.8853 42.6556 21.1086 42.8795 17.212C42.9023 16.8153 42.9047 16.4198 42.9169 16.0236C42.9185 15.9649 42.9035 15.9022 42.9549 15.8384C43.1089 15.8832 43.2475 15.9587 43.373 16.0695C44.873 17.3989 45.1271 19.9235 44.9649 21.7895C44.5797 26.207 42.1409 30.9215 38.2249 33.2022C38.1346 33.2546 38.0434 33.3056 37.9511 33.355C37.3464 33.6776 36.718 33.9312 36.0711 34.1483C35.9491 34.1892 35.8272 34.2306 35.7064 34.2715C36.2396 34.2416 36.977 34.1488 37.8124 33.8741C40.0461 33.1399 41.8253 31.4832 43.0607 29.5221C43.3646 29.0399 43.6372 28.5408 43.9034 28.0371C43.9196 28.0068 43.9358 27.9751 43.9772 27.9662C44.0265 27.9671 44.0465 28.0064 44.0634 28.0449C44.6838 29.4784 44.5238 30.9483 43.6494 32.2436C41.9278 34.7922 38.2897 36.3136 35.281 36.3258C32.508 36.3371 29.7357 36.3338 26.9627 36.3331C26.8753 36.3331 26.7428 36.3792 26.7188 36.256C26.6929 36.1251 26.8347 36.1407 26.9157 36.1038C31.1227 34.1695 34.3058 30.7951 36.3806 26.6741C38.1833 23.0932 39.0892 19.04 38.7362 15.0316C38.6232 13.7475 38.3849 12.474 38.0183 11.238C37.9964 11.1636 37.9657 11.0909 37.9511 11.0148C37.9008 10.7484 37.9798 10.6813 38.2521 10.7081C38.9332 10.7747 39.5341 11.0271 40.0696 11.4484C41.0829 12.2457 41.4716 13.6915 41.7057 14.9068C42.143 17.1829 41.6961 19.7042 41.164 21.9311C40.4719 24.8294 39.3035 27.6616 37.6188 30.1263C37.4393 30.3895 37.2315 30.6327 37.0386 30.8856C36.9871 30.9544 36.9401 31.0261 36.8903 31.0966Z",
    fill: "url(#paint0_linear_1_8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9139 21.5383C12.9094 21.1807 12.7987 20.821 12.4831 20.6201C12.1759 20.4248 11.7675 20.4287 11.5258 20.7258C11.5062 20.7499 11.4642 20.7908 11.4765 20.826C11.4888 20.8613 11.5649 20.8529 11.5968 20.8691C11.6517 20.8965 11.6735 20.9513 11.6718 21.0101C11.6696 21.0783 11.669 21.7302 11.6662 22.6288C10.8756 22.6243 10.0844 22.6193 9.29381 22.6148C9.27872 22.4184 9.2731 22.198 9.28711 21.9585C9.29996 21.7375 9.32852 21.5176 9.37159 21.3005C9.3906 21.2054 9.41243 21.1108 9.43706 21.0174C9.4639 20.9144 9.53832 20.788 9.5305 20.68C9.52937 20.6654 9.52601 20.6509 9.51706 20.6397C9.49581 20.6134 9.45494 20.6179 9.42251 20.6263C9.22107 20.6777 9.02525 20.7852 8.87081 20.9245C8.82326 20.967 8.69625 21.0879 8.58154 21.2938C8.27715 21.8387 8.25311 22.6109 8.25311 22.6109C8.23743 23.11 8.21786 24.1216 8.74997 25.1718C8.74997 25.1718 9.12261 25.908 9.65582 26.0895C9.76101 26.1252 9.78956 26.1017 9.79852 26.0899C9.8399 26.0368 9.75095 25.9452 9.72465 25.9043C9.67596 25.8293 9.63456 25.7499 9.59876 25.6676C9.5249 25.498 9.47565 25.3184 9.43929 25.1377C9.32795 24.5871 9.25576 24.0299 9.27143 23.4675H11.6662C11.6662 24.1719 11.6662 24.8764 11.6662 25.5809C11.6662 25.7207 11.7233 25.8556 11.8525 25.9217C11.9303 25.9614 12.0187 25.9753 12.1054 25.9858C12.2571 26.0049 12.412 26.015 12.562 25.9865C12.6498 25.9696 12.7377 25.9379 12.8032 25.8768C12.9089 25.7788 12.9106 25.6458 12.9106 25.5121C12.9106 24.4506 12.9207 23.3892 12.919 22.3278C12.919 22.0648 12.9173 21.8013 12.9139 21.5383Z",
    fill: "url(#paint1_linear_1_8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 26.3545C8.66652 26.0721 8.28939 25.0482 8.08292 24.1601C8.03815 23.9665 7.99508 23.7759 7.96934 23.5783C7.89212 22.9813 7.89548 22.3249 8.08908 21.7486C7.94135 21.7816 7.87478 21.9087 7.7886 22.0116C7.47361 22.3876 7.44898 22.8268 7.43387 23.2633C7.39806 24.2884 7.77239 25.0174 7.85574 25.1741C8.04374 25.5259 8.24855 25.7576 8.30896 25.8242C8.52382 26.062 8.73981 26.2272 8.90542 26.3367C8.77394 26.3043 8.58817 26.2434 8.38955 26.1207C8.20545 26.0072 8.07396 25.8808 7.98781 25.784C7.86303 25.6244 7.77519 25.4841 7.7181 25.3845C7.56425 25.118 7.37289 24.7864 7.27553 24.3415C7.2481 24.2168 7.22966 24.0896 7.1804 24.0847C7.10936 24.0774 7.02934 24.3303 7.012 24.3845C6.95605 24.5608 6.94206 24.7236 6.9426 24.8099C6.94653 25.1455 7.19831 25.7985 7.79981 26.2415C7.79981 26.2415 8.32577 26.6288 9.22546 26.6584C9.26241 26.6596 9.48006 26.6546 9.64177 26.5388C9.72176 26.4833 9.77435 26.3961 9.63281 26.3545Z",
    fill: "url(#paint2_linear_1_8)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09025 21.7453C8.08971 21.7464 8.08971 21.7475 8.08915 21.7487C8.09025 21.7487 8.09138 21.7481 8.09251 21.7475L8.09025 21.7453Z",
    fill: "url(#paint3_linear_1_8)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09007 21.7453L8.09286 21.7481L8.10405 21.7324L8.09007 21.7453Z",
    fill: "url(#paint4_linear_1_8)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2806 21.4135C25.2846 21.2904 25.2799 21.108 25.2364 20.8887C25.232 20.8652 25.2263 20.8093 25.1976 20.7443C25.1826 20.7091 25.1401 20.6157 25.0411 20.5519C24.988 20.5183 24.9286 20.4982 24.8661 20.4987C24.8224 20.4993 24.7786 20.5021 24.7356 20.5021C24.6752 20.5026 24.6148 20.5038 24.5542 20.5043C24.4367 20.5054 24.3192 20.5026 24.2024 20.5071C24.0971 20.511 23.9987 20.5468 23.9237 20.6257C23.8346 20.7192 23.7637 20.8523 23.6462 21.1377C23.6267 21.1847 23.6109 21.225 23.6003 21.2524C23.5555 21.3492 22.9239 22.7189 22.6849 23.115C22.6676 23.1447 22.6284 23.2079 22.5803 23.2057C22.5316 23.2079 22.493 23.1447 22.4757 23.115C22.2373 22.7183 21.6051 21.3492 21.5603 21.2524C21.5497 21.225 21.534 21.1853 21.5144 21.1377C21.3969 20.8523 21.3259 20.7192 21.2369 20.6257C21.1625 20.5468 21.064 20.511 20.9582 20.5071C20.8407 20.5032 20.7232 20.5054 20.6063 20.5043C20.5459 20.5038 20.4854 20.5026 20.425 20.5021C20.3814 20.5021 20.3377 20.4993 20.2947 20.4987C20.232 20.4982 20.1732 20.5183 20.1195 20.5519C20.0205 20.6157 19.978 20.7091 19.9629 20.7443C19.9343 20.8093 19.9287 20.8652 19.9242 20.8887C19.8806 21.1086 19.8761 21.291 19.88 21.4135C19.8342 22.823 19.7883 24.2313 19.7418 25.6409C19.7435 25.6644 19.748 25.6968 19.7609 25.733C19.833 25.9395 20.0949 26.0408 20.2963 26.0436C20.5 26.0465 20.7434 25.9496 20.8296 25.7628C20.8307 25.7605 20.8463 25.724 20.8547 25.6839C20.9146 25.3967 20.9493 23.0854 20.9622 22.0788C21.5139 23.209 21.9458 24.0539 22.145 24.4266C22.1853 24.5032 22.272 24.6571 22.4315 24.7098C22.4774 24.7253 22.5283 24.7338 22.5803 24.7342C22.6323 24.7338 22.6833 24.7253 22.7291 24.7098C22.8886 24.6571 22.9748 24.5032 23.0156 24.4266C23.2148 24.0539 23.6466 23.209 24.1984 22.0788C24.2113 23.086 24.2459 25.3967 24.3058 25.6839C24.3143 25.724 24.33 25.7605 24.331 25.7628C24.4172 25.9496 24.6607 26.0465 24.8642 26.0436C25.0663 26.0408 25.3276 25.9395 25.3997 25.733C25.4127 25.6968 25.4171 25.6644 25.4188 25.6409C25.373 24.2313 25.3269 22.8224 25.2806 21.4135Z",
    fill: "url(#paint5_linear_1_8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4537 24.7493C15.466 24.7511 15.4783 24.7533 15.4895 24.7565C15.4895 24.7577 15.4889 24.7582 15.4884 24.7594C15.4794 24.7751 15.4464 24.7662 15.4537 24.7493Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6428 20.6666C18.5281 20.5216 18.3323 20.516 18.1437 20.511C17.9653 20.506 17.7381 20.4998 17.596 20.6576C17.5171 20.7454 17.4953 20.849 17.4885 20.9116C17.4852 21.9518 17.4818 22.9914 17.4785 24.0316C17.4801 24.1333 17.4701 24.3253 17.3671 24.5361C17.2586 24.7589 17.1047 24.8853 17.0655 24.9161C17.0655 24.9161 16.8037 25.1231 16.4613 25.1506C16.4271 25.1535 16.3908 25.1544 16.3908 25.1544C16.3818 25.1551 16.3728 25.1551 16.3639 25.1551C16.3549 25.1551 16.346 25.1544 16.337 25.1544C16.337 25.1544 16.3012 25.1535 16.2665 25.1506C15.9241 25.1227 15.6623 24.9161 15.6623 24.9161C15.6225 24.8849 15.4692 24.7589 15.3607 24.5361C15.2577 24.3253 15.2476 24.1333 15.2493 24.0316C15.246 22.9914 15.2426 21.9518 15.2393 20.9116C15.2325 20.849 15.2113 20.7454 15.1318 20.6576C14.9897 20.4998 14.7625 20.506 14.5841 20.511C14.3961 20.516 14.1997 20.5216 14.085 20.6666C13.9949 20.7801 14.0021 20.9206 14.0094 20.9816C14.0094 22.0698 14.0094 23.1581 14.0094 24.2471C14.0094 24.5507 14.0967 24.953 14.3882 25.3351C14.7155 25.7645 15.1805 25.9557 15.3237 26.0089C15.6141 26.117 15.9 26.147 15.9873 26.1555C16.139 26.1705 16.2682 26.1712 16.3639 26.1684C16.4596 26.1712 16.5888 26.1705 16.7405 26.1555C16.8277 26.1466 17.1137 26.1163 17.404 26.0089C17.5473 25.9557 18.0123 25.7645 18.3396 25.3351C18.6305 24.953 18.7184 24.5507 18.7184 24.2471C18.7184 23.1587 18.7184 22.0704 18.7184 20.9816C18.7256 20.9211 18.7329 20.7807 18.6428 20.6666Z",
    fill: "url(#paint6_linear_1_8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7202 26.0972C15.7303 26.0989 15.7398 26.1017 15.7488 26.1057L15.7325 26.1158L15.7202 26.0972Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5988 22.2383C31.4411 21.714 31.1187 21.2518 30.6814 20.9228C30.185 20.5502 29.5696 20.3549 28.9513 20.3404C28.333 20.3549 27.7175 20.5502 27.2212 20.9228C26.783 21.2518 26.4608 21.714 26.3036 22.2383C25.8531 23.7435 26.5308 25.6636 28.1523 26.0883C28.4141 26.1567 28.6832 26.1856 28.9513 26.1785C29.2199 26.1856 29.489 26.1567 29.7503 26.0883C31.3723 25.6636 32.0493 23.7435 31.5988 22.2383ZM30.3954 23.9185C30.2257 24.6313 29.7524 25.3974 28.9513 25.4056C28.1499 25.3974 27.6767 24.6313 27.507 23.9185C27.3437 23.232 27.374 22.4235 27.7582 21.8108C28.0247 21.3861 28.4778 21.1349 28.9506 21.1315C29.4241 21.1349 29.8767 21.3867 30.143 21.8108C30.5286 22.4229 30.5582 23.2314 30.3954 23.9185Z",
    fill: "url(#paint7_linear_1_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8",
    x1: 24.6865,
    y1: 27.4287,
    x2: 45.5132,
    y2: 21.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_8",
    x1: 11.7678,
    y1: 23.912,
    x2: 7.93245,
    y2: 21.0094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_8",
    x1: 10.3351,
    y1: 25.8049,
    x2: 6.49975,
    y2: 22.9025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_8",
    x1: 11.4693,
    y1: 24.3047,
    x2: 7.63483,
    y2: 21.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_8",
    x1: 11.4763,
    y1: 24.2965,
    x2: 7.64115,
    y2: 21.3942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_8",
    x1: 25.9764,
    y1: 25.0959,
    x2: 20.016,
    y2: 21.9343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_8",
    x1: 19.2984,
    y1: 24.8031,
    x2: 13.3381,
    y2: 21.0713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_8",
    x1: 33.1554,
    y1: 25.7153,
    x2: 25.744,
    y2: 21.4135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#9C8837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5606,
    stopColor: "#F7E59E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#EFDD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6639,
    stopColor: "#DDCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#C4B062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7875,
    stopColor: "#B39F4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg45);
export default __webpack_public_path__ + "static/media/45.57b339cfdc60e53dfffbb3052349c1dd.svg";
export { ForwardRef as ReactComponent };